import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Controls from "../controls/Controls";
import {
    Grid, MenuItem, Box, Paper,
    Button, Stack, TextField, Modal, Typography,
    DialogActions,
    Divider,
    InputAdornment,
    IconButton
} from "@mui/material";
import useForm from "../common/useForm";
import Form from "../common/Form";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close"
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { addNewClientApi, getClientApi, getClientConfigApi, loadClientApi } from "../../store/clients";

const initialFormValues = {
    //issueStatus: "",
    id: 0,
    clientId: 0,
    apiBaseUrl: "",
    devOpsBaseUrl: "",
    devOpsOrgnization: "",
    devOpsProject: "",
    devOpsPat: "",
    addedBy: 1
};


const ClientApi = (props) => {

    const { setNotify, setOpenPopup, selectedClient, handleClientApi } = props;

    const [validateOnChange, setValidateOnChange] = useState(true);
    const [clientApiObj, setClientApiObj] = useState({});

    const dispatach = useDispatch();
    const validate = (fieldValues = formValues) => {
        let temp = { ...errors };
        // if ("issueStatus" in fieldValues)
        //   temp.issueStatus = fieldValues.issueStatus
        //     ? ""
        //     : "This field is required.";
        if ("reviewNotes" in fieldValues)
            temp.reviewNotes = fieldValues.reviewNotes
                ? ""
                : "This field is required.";

        setErrors({ ...temp });
        if (fieldValues === formValues)
            return Object.values(temp).every((x) => x === "");
    };

    const clientApiSelector = useSelector(getClientConfigApi);

    useEffect(() => {

        if (selectedClient?.id > 0)
            dispatach(loadClientApi(selectedClient.id))
    }, [selectedClient]);

    useEffect(() => {
        if (clientApiSelector)
            setClientApiObj(clientApiSelector)
        else setClientApiObj(initialFormValues)
    }, [clientApiSelector])

    const { formValues, errors, setErrors, handleOnChange, resetForm } = useForm(
        clientApiObj,
        validateOnChange,
        validate,
        setValidateOnChange
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            SaveClientApi({ ...formValues, clientId: selectedClient.id });
            setNotify({
                isOpen: true,
                message: "Saved Successfully",
                type: "success",
            });
            resetForm();
            handleClientApi("save");
        }
    };

    const SaveClientApi = (data) => {
        dispatach(addNewClientApi(data));
    };

    return <>
        <Form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography>Customer : {selectedClient?.name} ({selectedClient?.clientId})</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Controls.Input
                        rows={3}
                        name="apiBaseUrl"
                        label="Base URL"
                        onChange={handleOnChange}
                        value={formValues?.apiBaseUrl}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Controls.Input
                        rows={3}
                        name="devOpsBaseUrl"
                        label="DevOps Base URL"
                        onChange={handleOnChange}
                        value={formValues?.devOpsBaseUrl}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Controls.Input
                        rows={3}
                        name="devOpsOrgnization"
                        label="DevOps Organization"
                        onChange={handleOnChange}
                        value={formValues?.devOpsOrgnization}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Controls.Input
                        rows={3}
                        name="devOpsProject"
                        label="DevOps Project"
                        onChange={handleOnChange}
                        value={formValues?.devOpsProject}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Controls.InputAdornments
                        rows={3}
                        name="devOpsPat"
                        label="DevOps PAT"
                        onChange={handleOnChange}
                        value={formValues?.devOpsPat}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider sx={{ ml: -3, mr: -3, mb: 2 }} />
                    <Stack
                        spacing={2}
                        direction="row"
                        justifyContent="right"
                        alignItems="center"
                    >

                        <Controls.Button
                            text="Close"
                            color="error"
                            size="small"
                            variant="outlined"
                            onClick={() => handleClientApi(null)}
                            startIcon={<CloseIcon />}
                            sx={{
                                width:"80px",
                                '&:hover': {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    border: 'none',
                                }
                            }}
                        ></Controls.Button>

                        <Controls.Button
                            text="Save"
                            type="submit"
                            size="small"
                            variant="outlined"
                            startIcon={<SaveIcon />}
                            sx={{
                                width:"80px",
                                textTransform: 'none',
                                color: 'black',
                                border: "1px solid black",
                                '&:hover': {
                                  backgroundColor: 'black',
                                  color: 'white',
              
                                }
                              }}
                        ></Controls.Button>
                    </Stack>
                </Grid>
            </Grid>
        </Form>
    </>
}

export default ClientApi;